import { observable, computed } from 'mobx'

import Store from './store'

export default class PaginatedStore extends Store {
  @observable pagination = {}

  @computed get prevPage() {
    const { current_page } = this.pagination
    const prev = current_page - 1
    return prev > 0 ? prev : null
  }

  @computed get nextPage() {
    const { total_pages, current_page } = this.pagination
    const next = current_page + 1
    return next <= total_pages ? next : null
  }

  get currentPage() {
    return this.pagination.current_page
  }
  get totalPages() {
    return this.pagination.total_pages
  }
  get totalCount() {
    return this.pagination.total_count
  }
  get perPage() {
    return this.pagination.per_page
  }

  loadPage(page=1, query={}) {
    return this.connection.load(null, { ...query, page, per_page: 50 })
      .then(resp => resp.data)
      .then(({ results, meta }) => {
        this.records = results
        this.pagination = meta
      })
  }
}



// WEBPACK FOOTER //
// client/stores/paginated_store.js